function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DropdownMenu, DropdownMenuItem, IconButton, Spinner } from 'seagull';
import { Flag, CircledQuestion24 } from 'seagull/icons';
import { sendErrReport } from "../../../infra/utils";
import { Intent } from "../../../infra/access-control";
import { openInNewTabProps } from "../../../constants";
import styles from "./HelpMenu.module.scss";
import { useIoContext } from "../../../contexts";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
var ExternalLink;

(function (ExternalLink) {
  ExternalLink["Link"] = "link";
  ExternalLink["Action"] = "action";
})(ExternalLink || (ExternalLink = {}));

export function HelpMenu(_ref) {
  let {
    userId
  } = _ref;
  const [appcuesState, setAppcuesState] = useState(null);
  const location = useLocation();
  const {
    CONTACT_SUPPORT
  } = useFeatureFlags();
  const {
    getIntercom
  } = useIoContext();
  const externalLinks = useMemo(() => {
    return [_objectSpread({
      label: 'Ask support'
    }, CONTACT_SUPPORT ? {
      type: ExternalLink.Action,
      onClick: () => getIntercom()('showNewMessage')
    } : {
      type: ExternalLink.Link,
      href: 'mailto:support@sayanchor.com?subject=I have a question'
    }), {
      type: ExternalLink.Link,
      label: 'Help center',
      href: 'https://intercom.help/anchor-billing/en/'
    }, {
      type: ExternalLink.Link,
      label: 'Book a demo',
      href: 'https://meetings.hubspot.com/tal57/book-a-demo-website?utm_source=in-app&utm_medium=guide&utm_campaign=help_button'
    }, {
      type: ExternalLink.Link,
      label: "What's new",
      href: 'https://intercom.help/anchor-billing/en/collections/3297243-announcements'
    }, {
      type: ExternalLink.Link,
      label: 'Join the community',
      href: 'https://www.facebook.com/groups/sayanchor/'
    }];
  }, [CONTACT_SUPPORT]);
  useEffect(() => {
    setAppcuesState(null);
  }, [location]);

  async function appcuesRequest() {
    setAppcuesState({
      status: 'loading'
    });
    const url = new URL("https://api.appcues.com/v1/accounts/".concat(window.appcuesAccountId, "/users/").concat(userId, "/taco"));
    url.searchParams.set('url', window.location.href);

    try {
      const response = await fetch(url.toString());
      const {
        contents
      } = await response.json();

      if (contents) {
        const flows = contents.map(_ref2 => {
          let {
            name,
            id
          } = _ref2;
          return {
            name,
            id
          };
        });
        setAppcuesState({
          status: 'success',
          flows
        });
      } else {
        throw new Error('failed to load appcues because of missing data');
      }
    } catch (error) {
      sendErrReport(error);
      setAppcuesState({
        status: 'error'
      });
    }
  }

  return /*#__PURE__*/React.createElement(DropdownMenu, {
    minWidth: 175,
    onOpenChange: open => {
      if (open && window.Appcues && window.appcuesAccountId && appcuesState === null) {
        appcuesRequest();
      }
    },
    target: /*#__PURE__*/React.createElement(IconButton, {
      noPadding: true,
      intent: Intent.OpenHelpMenu,
      size: "small",
      "data-testid": "home-sidebar-help-menu-btn"
    }, /*#__PURE__*/React.createElement(CircledQuestion24, null))
  }, (appcuesState === null || appcuesState === void 0 ? void 0 : appcuesState.status) === 'loading' && /*#__PURE__*/React.createElement(DropdownMenuItem, {
    "data-testid": "home-sidebar-menuitem-appcues-spinner",
    iconStart: /*#__PURE__*/React.createElement(Spinner, {
      size: 24
    })
  }, "Loading\u2026"), (appcuesState === null || appcuesState === void 0 ? void 0 : appcuesState.status) === 'success' && appcuesState.flows.map(c => /*#__PURE__*/React.createElement(DropdownMenuItem, {
    iconStart: /*#__PURE__*/React.createElement(Flag, null),
    key: c.id,
    "data-testid": "home-sidebar-menuitem-appcues-campaign-".concat(c.name),
    onClick: () => {
      window.Appcues.show(c.id);
    }
  }, c.name)), ((appcuesState === null || appcuesState === void 0 ? void 0 : appcuesState.status) === 'success' && appcuesState.flows.length > 0 || (appcuesState === null || appcuesState === void 0 ? void 0 : appcuesState.status) === 'loading') && /*#__PURE__*/React.createElement("div", {
    "data-testid": "home-sidebar-menuitem-appcues-separator",
    className: styles.separator
  }), externalLinks.map(link => /*#__PURE__*/React.createElement(DropdownMenuItem, _extends({
    key: link.label,
    "data-testid": "home-sidebar-menuitem-".concat(link.label)
  }, link.type === ExternalLink.Link ? _objectSpread({
    as: 'a',
    href: link.href
  }, openInNewTabProps) : {
    onClick: link.onClick
  }), link.label)));
}